// テーマ外のカスタマイズ用

// タブ切り替え関数
export function initializeTabs(sectionId) {
  const selector = sectionId ? `#${sectionId}` : '';
  
  // 初期化処理 - 最初のタブにactiveクラスを付与
  function setupInitialState() {
    // 最初のメインタブにactiveクラスを付与
    const firstMainTab = document.querySelector(`${selector} .main-tab-nav span`);
    if (firstMainTab) {
      firstMainTab.classList.add('active');
    }
    
    // 最初のコンテンツエリアにactiveクラスを付与
    const firstContentArea = document.querySelector(`${selector} .tab-content-area`);
    if (firstContentArea) {
      firstContentArea.classList.add('active');
    }
    
    // 各コンテンツエリアの最初のサブタブと最初のサブコンテンツにactiveクラスを付与
    document.querySelectorAll(`${selector} .tab-content-area`).forEach(area => {
      const firstSubTab = area.querySelector('.sub-tab-nav span');
      const firstSubContent = area.querySelector('.sub-content');
      
      if (firstSubTab) {
        firstSubTab.classList.add('active');
      }
      if (firstSubContent) {
        firstSubContent.classList.add('active');
      }
    });
  }
  
  // メインタブの制御
  function setupMainTabs() {
    document.querySelectorAll(`${selector} .main-tab-nav span`).forEach((tab, mainIndex) => {
      tab.addEventListener('click', function() {
        // すべてのメインタブを非アクティブにする
        document.querySelectorAll(`${selector} .main-tab-nav span`).forEach(t => {
          t.classList.remove('active');
        });
        
        // すべてのコンテンツエリアを非表示にする
        document.querySelectorAll(`${selector} .tab-content-area`).forEach(area => {
          area.classList.remove('active');
        });
        
        // 選択されたタブとコンテンツをアクティブにする
        this.classList.add('active');
        const targetArea = document.querySelectorAll(`${selector} .tab-content-area`)[mainIndex];
        if (targetArea) {
          targetArea.classList.add('active');
        }
      });
    });
  }
  
  // 初期化実行
  setupInitialState();
  setupMainTabs();
}


// Splideスクロールバー関数
export function createSplideScrollbar(splideElement, scrollbarElement, options = {}) {
  const scrollbar = typeof scrollbarElement === 'string' ?
    document.querySelector(scrollbarElement) :
    scrollbarElement;
  const thumb = scrollbar.querySelector('.splide-scrollbar-thumb');

  if (!scrollbar || !thumb) {
    console.error('Scrollbar or thumb element not found');
    return null;
  }

  let isDragging = false;
  let animationFrame = null;
  let dragAnimationFrame = null;

  // デフォルト設定
  const config = {
    updateTransition: 'all 0.6s cubic-bezier(0.25, 1, 0.5, 1)',
    dragEndTransition: 'all 0.3s ease',
    ...options
  };

  // スクロールバーの位置を更新
  function updateScrollbar() {
    if (isDragging) return;

    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }

    animationFrame = requestAnimationFrame(() => {
      const totalSlides = splideElement.length;
      const currentIndex = splideElement.index;
      const maxIndex = splideElement.Components.Controller.getEnd();

      if (maxIndex === 0) return;

      const progress = currentIndex / maxIndex;
      const thumbWidth = (splideElement.options.perPage / totalSlides) * 100;

      thumb.style.transition = config.updateTransition;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (progress * (100 - thumbWidth)) + '%';
    });
  }

  // ドラッグ処理
  function handleDrag(clientX) {
    if (!isDragging) return;

    if (dragAnimationFrame) {
      cancelAnimationFrame(dragAnimationFrame);
    }

    dragAnimationFrame = requestAnimationFrame(() => {
      const rect = scrollbar.getBoundingClientRect();
      const clickPosition = clientX - rect.left;
      const scrollbarWidth = rect.width;
      const totalSlides = splideElement.length;
      const thumbWidth = (splideElement.options.perPage / totalSlides) * 100;
      const thumbWidthPx = (thumbWidth / 100) * scrollbarWidth;

      // サムの中心位置を基準に計算
      let newThumbLeft = clickPosition - (thumbWidthPx / 2);
      const maxThumbLeft = scrollbarWidth - thumbWidthPx;
      newThumbLeft = Math.max(0, Math.min(newThumbLeft, maxThumbLeft));

      // パーセンテージに変換
      const newThumbLeftPercent = (newThumbLeft / scrollbarWidth) * 100;
      const maxLeftPercent = 100 - thumbWidth;

      // スクロールバーの位置を直接更新
      thumb.style.transition = 'none';
      thumb.style.left = Math.min(newThumbLeftPercent, maxLeftPercent) + '%';

      // スライダーの位置を計算
      const progress = Math.max(0, Math.min(1, newThumbLeftPercent / maxLeftPercent));
      const targetIndex = Math.round(progress * splideElement.Components.Controller.getEnd());

      splideElement.go(targetIndex, false);
    });
  }

  // イベントリスナーの登録
  function bindEvents() {
    // Splideイベント
    splideElement.on('move', updateScrollbar);
    splideElement.on('moved', updateScrollbar);
    splideElement.on('mounted', updateScrollbar);
    splideElement.on('resize', updateScrollbar);

    // スクロールバーのクリックイベント
    scrollbar.addEventListener('click', function (e) {
      if (e.target === thumb) return;

      const rect = scrollbar.getBoundingClientRect();
      const progress = (e.clientX - rect.left) / rect.width;
      const targetIndex = Math.round(progress * splideElement.Components.Controller.getEnd());

      splideElement.go(targetIndex);
    });

    // マウスドラッグ
    thumb.addEventListener('mousedown', function (e) {
      isDragging = true;
      e.preventDefault();

      function onMouseMove(e) {
        handleDrag(e.clientX);
      }

      function onMouseUp() {
        isDragging = false;
        thumb.style.transition = config.dragEndTransition;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    // タッチドラッグ
    thumb.addEventListener('touchstart', function (e) {
      isDragging = true;
      e.preventDefault();

      function onTouchMove(e) {
        handleDrag(e.touches[0].clientX);
      }

      function onTouchEnd() {
        isDragging = false;
        thumb.style.transition = config.dragEndTransition;
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
      }

      document.addEventListener('touchmove', onTouchMove);
      document.addEventListener('touchend', onTouchEnd);
    });
  }

  // 破棄処理
  function destroy() {
    if (animationFrame) cancelAnimationFrame(animationFrame);
    if (dragAnimationFrame) cancelAnimationFrame(dragAnimationFrame);

    splideElement.off('move', updateScrollbar);
    splideElement.off('moved', updateScrollbar);
    splideElement.off('mounted', updateScrollbar);
    splideElement.off('resize', updateScrollbar);
  }

  // 初期化
  bindEvents();

  // パブリックAPI
  return {
    update: updateScrollbar,
    destroy: destroy,
    setConfig: (newConfig) => Object.assign(config, newConfig)
  };
}

// ------------------ Splideスクロールバー関数ここまで
(function () {
  const fallbackId = "fgaz-hulk-fallback-connection-position";
  const optionName = "コンセント位置";
  const displayTitle = "ベッドヘッド　コンセント位置";
  const preferredValues = ["右側", "左側", "両側"];

  function hasNativeOption() {
    return Boolean(
      document.querySelector(".hulkapps_product_options, .hulkapps_option") ||
        document.querySelector('input[name="properties[コンセント位置]"]')
    );
  }

  function findProductForm() {
    return document.querySelector(
      'product-form-component form[action*="/cart/add"], form.shopify-product-form[action*="/cart/add"], form[action*="/cart/add"]'
    );
  }

  function getProductCollections() {
    const hulkapps = window.hulkapps || {};
    if (Array.isArray(hulkapps.product_collection)) {
      return hulkapps.product_collection.join(",");
    }
    if (typeof hulkapps.product_collections === "string") {
      return hulkapps.product_collections;
    }
    return "";
  }

  function getProductTags() {
    const product = window.hulkapps && window.hulkapps.product;
    if (product && Array.isArray(product.tags)) {
      return product.tags.join(",");
    }
    return "";
  }

  async function loadHulkOption() {
    const hulkapps = window.hulkapps || {};
    if (hulkapps.page_type !== "product" || !hulkapps.product_id || !hulkapps.po_url) {
      return null;
    }

    const product = hulkapps.product || {};
    const body = new URLSearchParams({
      hpage_type: "product",
      pid: String(hulkapps.product_id),
      store_id: hulkapps.store_id || "",
      tags: getProductTags(),
      vendor: product.vendor || "",
      ptype: product.type || "",
      customer_tags: hulkapps.customer && hulkapps.customer.tags ? hulkapps.customer.tags : "",
      product_collections: getProductCollections(),
      shopify_currency_rate: String(window.hulkapps_shopify_rate || 1),
    });

    const response = await fetch(`${hulkapps.po_url}/api/v2/store/get_all_relationships`, {
      method: "POST",
      body,
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    const options = data && data.option_associative_array ? data.option_associative_array : {};
    return Object.values(options).find((option) => option && option.option_name === optionName) || null;
  }

  function parseOptionValues(option) {
    try {
      const rawValues = JSON.parse(option.values_json || "[]");
      const values = rawValues.map((row) => row && row[0]).filter(Boolean);
      const orderedValues = preferredValues.filter((value) => values.includes(value));
      return orderedValues.length ? orderedValues : values;
    } catch (error) {
      return preferredValues;
    }
  }

  function addStyle() {
    if (document.getElementById(`${fallbackId}-style`)) {
      return;
    }

    const style = document.createElement("style");
    style.id = `${fallbackId}-style`;
    style.textContent = `
      #${fallbackId} {
        margin: 18px 0 20px;
      }

      #${fallbackId} .fgaz-hulk-fallback__title {
        margin: 0 0 10px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      #${fallbackId} .fgaz-hulk-fallback__choices {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      #${fallbackId} .fgaz-hulk-fallback__choice {
        position: relative;
        min-width: 92px;
        border: 1px solid rgba(18, 18, 18, 0.22);
        border-radius: 2px;
        padding: 11px 18px;
        background: #fff;
        color: rgb(var(--color-foreground, 18, 18, 18));
        font-size: 14px;
        line-height: 1.2;
        text-align: center;
        cursor: pointer;
        transition: border-color 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
      }

      #${fallbackId} .fgaz-hulk-fallback__choice:hover,
      #${fallbackId} .fgaz-hulk-fallback__choice.is-selected {
        border-color: rgba(18, 18, 18, 0.78);
        box-shadow: inset 0 0 0 1px rgba(18, 18, 18, 0.78);
      }

      #${fallbackId} .fgaz-hulk-fallback__choice input {
        position: absolute;
        inset: 0;
        opacity: 0;
        cursor: pointer;
      }
    `;
    document.head.appendChild(style);
  }

  function updateSelectedState(container) {
    container.querySelectorAll(".fgaz-hulk-fallback__choice").forEach((label) => {
      const input = label.querySelector("input");
      label.classList.toggle("is-selected", Boolean(input && input.checked));
    });
  }

  function renderFallback(values) {
    if (hasNativeOption() || document.getElementById(fallbackId)) {
      return;
    }

    const productForm = findProductForm();
    const targetFieldset = document.querySelector('variant-picker fieldset[data-option-id*="-パイピング"]');
    const variantForm = document.querySelector("variant-picker .variant-picker__form");
    const target = targetFieldset || variantForm;

    if (!productForm || !productForm.id || !target || !values.length) {
      return;
    }

    addStyle();

    const container = document.createElement("div");
    container.id = fallbackId;
    container.setAttribute("data-fgaz-hulk-fallback", "connection-position");

    const title = document.createElement("p");
    title.className = "fgaz-hulk-fallback__title";
    title.textContent = displayTitle;

    const choices = document.createElement("div");
    choices.className = "fgaz-hulk-fallback__choices";

    values.forEach((value, index) => {
      const inputId = `${fallbackId}-${index}`;
      const label = document.createElement("label");
      label.className = "fgaz-hulk-fallback__choice";
      label.setAttribute("for", inputId);

      const input = document.createElement("input");
      input.id = inputId;
      input.type = "radio";
      input.name = "properties[コンセント位置]";
      input.value = value;
      input.required = true;
      input.setAttribute("form", productForm.id);

      const text = document.createElement("span");
      text.textContent = value;

      label.append(input, text);
      choices.appendChild(label);
    });

    container.append(title, choices);
    target.insertAdjacentElement("afterend", container);
    container.addEventListener("change", () => updateSelectedState(container));
    updateSelectedState(container);
  }

  function boot(attempt) {
    if (hasNativeOption() || document.getElementById(fallbackId)) {
      return;
    }

    loadHulkOption()
      .then((option) => {
        if (!option || hasNativeOption() || document.getElementById(fallbackId)) {
          return;
        }
        renderFallback(parseOptionValues(option));
      })
      .catch(() => {});

    if (attempt < 5) {
      window.setTimeout(() => boot(attempt + 1), 1400);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => window.setTimeout(() => boot(0), 1200));
  } else {
    window.setTimeout(() => boot(0), 1200);
  }
})();